var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 29.561,
    viewBox: "0 0 49 29.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4a87f8;}.b{fill:#3760ac;}.c{fill:#4b87ff;}.d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1442.93 -159.229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1442.85 159.229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.682,
    height: 5.861,
    transform: "translate(37.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1823.219,159.229a4.129,4.129,0,0,1,4.13,4.13v1.732h-8.259v-1.732A4.129,4.129,0,0,1,1823.219,159.229Z",
    transform: "translate(-1778.269 -159.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1483.671,159.229v16.62c0,3.575-2.286,6.809-5.977,9.152a27.334,27.334,0,0,1-14.433,3.79c-11.271,0-20.411-5.8-20.411-12.942V162.395c0-1.749,2.235-3.166,4.993-3.166Z",
    transform: "translate(-1442.77 -159.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5.5-4.368a2.055,2.055,0,0,1,1.23.726A2.061,2.061,0,0,1,7.188-2.3,2.114,2.114,0,0,1,6.474-.618,3.076,3.076,0,0,1,4.4,0H.768V-8.472H4.332a3.046,3.046,0,0,1,1.974.564A1.931,1.931,0,0,1,7-6.324a1.975,1.975,0,0,1-.414,1.3A1.925,1.925,0,0,1,5.5-4.368ZM2.46-4.92H3.984A1.45,1.45,0,0,0,4.95-5.2a1.007,1.007,0,0,0,.33-.81,1.035,1.035,0,0,0-.324-.816,1.466,1.466,0,0,0-1-.288H2.46ZM4.068-1.38A1.594,1.594,0,0,0,5.1-1.674a1.043,1.043,0,0,0,.36-.858,1.071,1.071,0,0,0-.366-.87,1.575,1.575,0,0,0-1.038-.306H2.46V-1.38Zm6-5.748v2.2h3v1.3h-3v2.28h3.36V0H8.376V-8.472h5.052v1.344ZM20.436-8.472v1.344H18.1V0H16.4V-7.128H14.076V-8.472Zm6.1,6.768h-3.4l-.6,1.7H20.748l3.12-8.376H25.8L28.908,0H27.12Zm-.456-1.284L24.828-6.564,23.58-2.988Z",
    transform: "translate(6.08 18.775)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.a7a718dce2b7d35398c0a48ab90c37e1.svg";
export { ForwardRef as ReactComponent };